var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.canNavigate)?_c('RouterLink',{staticClass:"tw-no-underline hover:tw-underline avatar-link",attrs:{"to":_vm.myYearPageLink}},[_vm._t("default")],2):_c('span',{staticClass:"tw-font-semibold"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }